import { Database } from "lucide-react";
import { useSyncStatus } from "../lib/queries";
import { timeAgo } from "../lib/format";

const STALE_HOURS = 26; // daily sync cadence plus slack

/** "Data as of …" indicator for dashboards — surfaces how fresh the vendor
 * sync is (amber when overdue, red when the last run errored). */
export default function SyncFreshnessBadge() {
  const { data } = useSyncStatus();
  if (!data?.configured) return null;
  const asOf = data.watermark ?? data.last_success_at;
  if (!asOf && !data.last_error) return null;

  const ageHours = asOf ? (Date.now() - new Date(asOf).getTime()) / 3_600_000 : Infinity;
  const color = data.last_error ? "#EF4444" : ageHours > STALE_HOURS ? "#F59E0B" : undefined;
  const title = data.last_error
    ? `Last sync failed: ${data.last_error}`
    : asOf
      ? new Date(asOf).toLocaleString("en-AU")
      : undefined;

  return (
    <span
      className="flex items-center gap-1.5 text-[11px] text-slatey"
      style={color ? { color } : undefined}
      title={title}
    >
      <Database size={13} />
      {data.running ? "syncing…" : asOf ? `Data as of ${timeAgo(asOf)}` : "sync error"}
    </span>
  );
}
